export default {
    SET_PAYMENT_GENERATED_LINK: (state, link) => {
        state.paymentGeneratedLink = link
    }
}
